module.exports = __webpack_public_path__ + "static/video-a84bb80b3440fe710b24e9511eff17a2.mp4";